"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOfAdequateLength = exports.invoke = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const invoke = (fn, arg) =>
// eslint-disable-next-line
Array.isArray(arg) ? fn.apply(null, arg) : fn(arg);
exports.invoke = invoke;
const isOfAdequateLength = (term, len) => {
  const meetsReq = v => typeof v === 'string' && v.length >= len;
  return Array.isArray(term) ? meetsReq(term[0]) : meetsReq(term);
};
exports.isOfAdequateLength = isOfAdequateLength;
var _default = function (service, term) {
  let defaultState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  let minimumCharacterCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  const [loading, setLoading] = _react.default.useState(false);
  const [results, setResults] = _react.default.useState(defaultState);
  const cache = _react.default.useRef({});
  const invokeService = _react.default.useCallback(stateValues => {
    setLoading(true);
    return invoke(service, [term, stateValues]).then(r => {
      cache.current[term] = r;
      setResults(r);
      return r;
    }).catch(() => {
      const out = [];
      setResults(out);
      return out;
    }).finally(() => {
      setLoading(false);
    });
  }, [term, loading]);
  _react.default.useEffect(() => {
    return () => {
      cache.current = {};
    };
  });
  return {
    invokeService,
    run: _react.default.useCallback(stateValues => {
      if (!isOfAdequateLength(term, minimumCharacterCount)) return setResults([]);
      try {
        if (cache.current[term.toLowerCase()] && cache.current[term.toLowerCase()].length) {
          setResults(cache.current[term.toLowerCase()]);
          return null;
        }
        throw new Error('Cache not found');
      } catch (e) {
        return invokeService(stateValues);
      }
    }, [term]),
    loading,
    results,
    setResults
  };
};
exports.default = _default;